export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15023.50b7e6f9.jpg";